import { render, staticRenderFns } from "./item_footer.vue?vue&type=template&id=4b1e71fe&scoped=true&"
import script from "./item_footer.vue?vue&type=script&lang=js&"
export * from "./item_footer.vue?vue&type=script&lang=js&"
import style0 from "./item_footer.vue?vue&type=style&index=0&id=4b1e71fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1e71fe",
  null
  
)

export default component.exports